import Vue from 'vue'

// Pollyfills
import svg4everybody from 'svg4everybody'
import objectFitImages from 'object-fit-images'
import smoothscroll from 'smoothscroll-polyfill'

// SASS
import '../styles/main.scss'

// Helper function for registration
import register from './util/functions/register'

// Plugins
import Tabs from './components/tabs/index'
import Modal from './components/modal/index'
import Player from './components/player/index'
import Carousel from './components/carousel/index'
import Accordion from './components/accordion/index'

// Accessibility
import DiscernibleContent from './components/DiscernibleContent'

// Window Width
import BaseWindowWidth from './components/BaseWindowWidth'

// Base Filter
import BaseFilter from './components/BaseFilter'
// filtered results
import BaseFilterResultsList from './components/BaseFilterResultsList'
import BaseFilterResultsItem from './components/BaseFilterResultsItem'
// filter elements
import BaseFilterInput from './components/BaseFilterInput'
import BaseFilterSelect from './components/BaseFilterSelect'
import BaseFilterCheckbox from './components/BaseFilterCheckbox'
// load more button
import BaseFilterLoadMoreButton from './components/BaseFilterLoadMoreButton'
// Modal comparison button
import BaseFilterModalButton from './components/BaseFilterModalButton'
// Program finder checkbox
import BaseFilterProgramCheckbox from './components/BaseFilterProgramCheckbox'

// filter reset button
import BaseFilterReset from './components/BaseFilterReset'
// gettings data
import BaseFilterDispatch from './components/BaseFilterDispatch'

// Random Id
import RandomId from './components/RandomId'

// Silent Background Video
import SilentVideo from './components/SilentVideo'
import SilentVideoContent from './components/SilentVideoContent'
import SilentVideoButton from './components/SilentVideoButton'

// Disclosure
import DisclosureButton from './components/disclosure/DisclosureButton'
import DisclosureContent from './components/disclosure/DisclosureContent'
import DisclosureTransition from './components/disclosure/DisclosureTransition'

// Search Results Input
import SearchForm from './components/SearchForm'

// Wysiwyg
import BaseWysiwyg from './components/BaseWysiwyg'

// BaseToggle
import BaseToggle from './components/BaseToggle'
import BaseToggleButton from './components/BaseToggleButton'

// Transitions
import TransitionMenu from './components/TransitionMenu'
import TransitionSearch from './components/TransitionSearch'

// Base Scroll
import BaseScrollButton from './components/BaseScrollButton'

const Components = {
  RandomId,
  BaseFilter,
  BaseFilterReset,
  BaseFilterDispatch,
  BaseFilterResultsList,
  BaseFilterResultsItem,
  BaseFilterInput,
  BaseFilterSelect,
  BaseFilterCheckbox,
  SilentVideo,
  SilentVideoContent,
  SilentVideoButton,
  BaseWindowWidth,
  DiscernibleContent,
  DisclosureButton,
  DisclosureContent,
  DisclosureTransition,
  SearchForm,
  BaseWysiwyg,
  BaseToggle,
  BaseToggleButton,
  BaseFilterModalButton,
  BaseFilterLoadMoreButton,
  BaseFilterProgramCheckbox,
  TransitionMenu,
  TransitionSearch,
  BaseScrollButton,
}

// Component Registration
register(Vue, Components)

// Plugin Invocation
Vue.use(Tabs)
Vue.use(Modal)
// Might not need?
Vue.use(Player)
Vue.use(Carousel)
Vue.use(Accordion)

new Vue({
  delimiters: ['<%', '%>'],
  mounted() {
    // Polyfill invocation
    svg4everybody()
    objectFitImages()
    smoothscroll.polyfill()
  },
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/js/main.js